import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel, UIComponentState } from '../uicomponent';
import * as React from 'react';
import { NavBlockComponentProps } from './navblockcomponent';
import { NavBlockCSSStyle } from './navblockcss';


export class NavBlockViewImpl extends UIComponentViewImpl<UIDataModel>
{
    draw(props: NavBlockComponentProps, state: UIComponentState, cssStyle: NavBlockCSSStyle): JSX.Element | boolean
    {
        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                <h2 style={cssStyle.getTitleCSSStyle()}>
                    {props.title}
                </h2>
                <ul style={cssStyle.getUnorderListCSSStyle()}>
                    {props.list.map((entry, index)=>
                        <li key={index} style={cssStyle.getListItemCSSStyle()}>
                            <a target="_blank" href={props.links[entry] !== undefined ? props.links[entry] : "#"} style={cssStyle.getAnchorCSSStyle()}>{entry}</a>
                        </li>
                        )}
                </ul>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/footer-native/navblockview.tsx